(function () {
  'use strict';
  var translations = {
    'We respect your privacy': 'Spoštujemo vašo zasebnost',
    'This website uses cookies to ensure you get the best experience.': 'Ta spletna stran uporablja piškotke za pravilno delovanje in boljšo uporabniško izkušnjo.',
    'Ok': 'V redu', 'Learn more': 'Več informacij', 'Preferences': 'Nastavitve',
    'Accept': 'Sprejmi', 'Decline': 'Zavrni', 'Cookie policy': 'Pravilnik o piškotkih',
    'Manage consent preferences': 'Nastavitve soglasja', 'Close': 'Zapri',
    'Accept all': 'Sprejmi vse', 'Reject all': 'Zavrni vse', 'Save preferences': 'Shrani nastavitve',
    'Strictly necessary cookies': 'Nujni piškotki', 'Functional cookies': 'Funkcionalni piškotki',
    'Performance cookies': 'Analitični piškotki', 'Targeting cookies': 'Oglaševalski piškotki',
    'Unclassified cookies': 'Nerazvrščeni piškotki', 'Always allowed': 'Vedno dovoljeno',
    'Submit': 'Pošlji', 'Cancel': 'Prekliči'
  };
  function addSlovenianTexts() {
    var settings = window.PandectesSettings;
    if (!settings || !settings.texts) return;
    if (settings.store) settings.store.primaryLocale = 'sl';
    if (settings.language) { settings.language.fallbackLanguage = 'sl'; settings.language.languagesSupported = ['sl']; }
    ['managed', 'categories', 'auto'].forEach(function (group) {
      var values = settings.texts[group] || {};
      Object.keys(values).forEach(function (key) {
        var entry = values[key];
        if (!entry || typeof entry !== 'object') return;
        var english = entry.en;
        if (english && translations[english]) entry.sl = translations[english];
      });
    });
  }
  function translateVisibleText(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      var value = root.nodeValue.trim();
      if (translations[value]) root.nodeValue = root.nodeValue.replace(value, translations[value]);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE && root.getAttribute('aria-label') === 'Close') root.setAttribute('aria-label', 'Zapri');
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue.trim();
      if (translations[text]) node.nodeValue = node.nodeValue.replace(text, translations[text]);
    }
  }
  addSlovenianTexts();
  if (document.documentElement) {
    new MutationObserver(function (records) {
      records.forEach(function (record) { record.addedNodes.forEach(translateVisibleText); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { translateVisibleText(document.body); });
  else translateVisibleText(document.body);
})();

// Correct the Slovenian Pandectes cookie notice after the app injects it.
(function () {
  function fixCookieNotice() {
    var message = document.querySelector('#pandectes-banner .cc-message');
    if (!message) return;

    var detailsLink = message.querySelector('.cc-link');
    if (detailsLink) detailsLink.setAttribute('href', '/pages/piskotki');

    if (message.textContent.indexOf('Ta spletna stran uporabljaj') === -1) return;

    var walker = document.createTreeWalker(message, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      node.nodeValue = node.nodeValue.replace('Ta spletna stran uporabljaj', 'Ta spletna stran uporablja');
    }
  }

  fixCookieNotice();
  new MutationObserver(fixCookieNotice).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

// Keep rapid collection-filter changes in order. Older AJAX responses must not
// overwrite the result of the visitor's latest filter selection.
(function () {
  'use strict';

  if (window.__borimoFacetsGuard || typeof window.fetch !== 'function') return;
  window.__borimoFacetsGuard = true;

  var nativeFetch = window.fetch.bind(window);
  var pendingSections = Object.create(null);

  function getSectionKey(resource, options) {
    var method = (options && options.method) || 'GET';
    if (String(method).toUpperCase() !== 'GET') return null;

    var url = typeof resource === 'string' ? resource : resource && resource.url;
    if (!url || url.indexOf('section_id=') === -1) return null;

    try {
      var parsedUrl = new URL(url, window.location.origin);
      if (parsedUrl.origin !== window.location.origin) return null;
      if (parsedUrl.pathname.indexOf('/collections/') === -1 && parsedUrl.pathname.indexOf('/search') === -1) return null;
      return parsedUrl.searchParams.get('section_id');
    } catch (error) {
      return null;
    }
  }

  window.fetch = function (resource, options) {
    var sectionKey = getSectionKey(resource, options);
    if (!sectionKey) return nativeFetch(resource, options);

    if (pendingSections[sectionKey]) pendingSections[sectionKey].abort();

    var controller = new AbortController();
    pendingSections[sectionKey] = controller;
    var requestOptions = Object.assign({}, options || {}, { signal: controller.signal });

    return nativeFetch(resource, requestOptions).finally(function () {
      if (pendingSections[sectionKey] === controller) delete pendingSections[sectionKey];
    });
  };

  document.addEventListener('click', function (event) {
    var filterLink = event.target.closest('.t4s-filter__values li:not(.is--selected) a');
    if (!filterLink) return;

    var countElement = filterLink.querySelector('.t4s-value-count');
    if (countElement && /^\s*\(0\)\s*$/.test(countElement.textContent)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
